import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import { Icon } from "antd";
import styles from "./styles/FavoriteCount.scss";
import { PageRoute } from "../../models/enums";
import { selectFavoriteIds } from "../../routes/Favorite/favorite.ducks";
import { getIconUrl } from "../../services/asset";
import ReactGA from "react-ga4";

function FavoriteCount(props: any) {
  const { favoriteIds, routePath, mobile } = props;
  const [hover, setHover] = useState(false);

  const handleMouseEnter = () => {
    setHover(true);
  };

  const handleMouseLeave = () => {
    setHover(false);
  };

  return (
    <span>
      <Link
        onClick={() =>
          ReactGA.event({
            category: "Spremanje oglasa",
            action: "Click",
            label: "Lista sprijemljenih oglasa u headeru"
          })
        }
        title={"Spremljeni oglasi"}
        className={styles.text}
        to={PageRoute.favorite}
        rel="noopener noreferrer nofollow"
      >
        {mobile ? (
          <Icon type="heart" />
        ) : (
          <span onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <img
              alt={"Spremljeni oglasi"}
              src={getIconUrl(
                !hover ? "heart_black.svg" : "heart_chosen_hover.svg"
              )}
              className={styles.favoriteIcon}
            />
            {"Spremljeni oglasi"}
            {/* Hide favorite count number */}

            {/* {`(${favoriteIds ? favoriteIds.length : 0})`}  */}
          </span>
        )}
      </Link>
    </span>
  );
}

FavoriteCount.defaultProps = {
  favoriteIds: [],
  mobile: false
};

export default connect((state: any) => ({
  favoriteIds: selectFavoriteIds(state),
  routePath: state.router.location.pathname
}))(FavoriteCount);



// WEBPACK FOOTER //
// ./src/containers/FavoriteCount/index.tsx